// First-touch attribution. Captured silently on the first page a visitor
// lands on and kept in localStorage, so the order knows where the customer
// came from even if they browse for twenty minutes first.

var KEY = 'jm_attr_first';
var PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid'];

export function captureAttribution() {
  try {
    if (localStorage.getItem(KEY)) return; // first touch wins
    var qs = new URLSearchParams(window.location.search);
    var data = { referrer: document.referrer || '', landing: window.location.pathname, at: new Date().toISOString() };
    for (var i = 0; i < PARAMS.length; i++) {
      var v = qs.get(PARAMS[i]);
      if (v) data[PARAMS[i]] = v.slice(0, 120);
    }
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch (e) { /* private mode — tracking is optional, never break the site */ }
}

export function getAttribution() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '{}');
  } catch (e) {
    return {};
  }
}
